import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faBarsStaggered } from "@fortawesome/free-solid-svg-icons";
import {} from "@fortawesome/free-regular-svg-icons";
import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import {
  faTrash,
  faCaretDown,
  faAngleUp,
  faAngleDown,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useCart } from "../../Context/CartContext";
import ShopSidebar from "../ShopSidebar";
import envConstants, { API_BASE_PUBLIC_URL } from "../../Constants";
import axios from "../../Axiosapi";
import env_constants from "../../Constants";
import { Link, useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import { AuthContext } from "../../Context/AuthContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [setAccountDrop] = useState(false);
  const { cart, dispatch } = useCart();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const closeSidebar = () => setSidebar(false);
  const [categories, setCategories] = useState([]);
  const cartSidebarRef = useRef(null);
  const mobileRef = useRef(null);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);
  const productimagenotfound =
    "../../../public/assets/images/product-image-not-found.webp";
  const [brands, setBrands] = useState([]);
  const { user } = useContext(AuthContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { API_BASE_URL, API_BASE_PUBLIC_URL } = env_constants;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAccountDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // If sidebar is closed, do nothing
      if (!sidebar) return;

      // If click is inside the sidebar OR on the cart icon, keep it open
      const cartIconBtn = document.querySelector(".header-icon.cart-icon");
      if (
        (cartSidebarRef.current &&
          cartSidebarRef.current.contains(event.target)) ||
        (cartIconBtn && cartIconBtn.contains(event.target))
      ) {
        return;
      }

      // Otherwise close it
      setSidebar(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [sidebar, setSidebar]);
  const increaseQuantity = (product) => {
    const newQuantity = product.quantity + 1;
    dispatch({
      type: "UPDATE_QUANTITY",
      payload: { id: product.id, quantity: newQuantity },
    });
  };

  const decreaseQuantity = (product) => {
    if (product.quantity > 1) {
      const newQuantity = product.quantity - 1;
      dispatch({
        type: "UPDATE_QUANTITY",
        payload: { id: product.id, quantity: newQuantity },
      });
    }
  };

  useEffect(() => {
    if (location.pathname === "/cart") {
      setSidebar(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (cart.length > 0 && location.pathname !== "/cart") {
      setSidebar(true);
    }
  }, [cart, location.pathname]);

  const isCartEmpty = !cart || cart.length === 0;

  const totalPrice = cart.reduce((total, product) => {
    const priceMeta = product.product_meta.find(
      (meta) => meta.option === "_price"
    );
    const originalPrice = priceMeta ? parseFloat(priceMeta.value) : 0;

    const discountData = product.discount_data;
    let finalPrice = originalPrice;

    if (discountData && discountData.discounted_price) {
      finalPrice = parseFloat(discountData.discounted_price);
    }

    return total + product.quantity * finalPrice;
  }, 0);

  const removeProduct = (id) => {
    dispatch({ type: "REMOVE_FROM_CART", payload: id });
  };
  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const handleLinkClick = () => {
    setIsDropdownOpen(false);
  };
  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileRef.current && !mobileRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const ToggleSidebar = useCallback(
    _.debounce(() => {
      setIsOpen((prevState) => !prevState);
    }, 300),
    []
  );

  const fetchNavbar = useCallback(async () => {
    try {
      const response = await axios.get(
        `${envConstants.API_BASE_URL}/nav-bar-data`
      );
      setCategories(response.data.data.category);
      setBrands(response.data.data.brand);
      setError(null);
    } catch (error) {
      setError(error);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNavbar();
  }, [fetchNavbar]);

  return (
    <>
      <div className="navbar py-3">
        <div className="container p-0 px-sm-2 position-relative">
          <div className="d-flex main-navbar">
            <div className="navbar-items align-items-center">
              <div className="nav-icons-wrapper">
  <button className="all-category-btn" onClick={ToggleSidebar}>
    <div className="category-icon-box">
     
       <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60px"
                    height="40px"
                    viewBox="0 0 40 40"
                    fill="#FFF"
                  >
                    <g>
                      <path
                        d="M20,21.569c-0.095,0-0.189-0.021-0.282-0.062L5.434,15.115C5.165,14.995,4.994,14.72,5,14.413
          c0.006-0.303,0.191-0.578,0.46-0.683l14.286-5.681C19.828,8.017,19.913,8,20,8c0.086,0,0.172,0.017,0.254,0.049l14.285,5.679
          c0.275,0.11,0.455,0.378,0.461,0.683c0.008,0.308-0.163,0.584-0.434,0.704L20.281,21.51C20.192,21.549,20.096,21.569,20,21.569
          L20,21.569z M7.626,14.468l12.339,5.522l12.409-5.522L20,9.549L7.626,14.468z"
                      />
                      <path
                        d="M5.434,20.49c-0.361-0.163-0.53-0.604-0.376-0.983c0.113-0.275,0.372-0.454,0.659-0.454
          c0.097,0,0.191,0.021,0.282,0.062l13.967,6.249l14.037-6.249c0.092-0.042,0.186-0.062,0.283-0.062c0.286,0,0.544,0.177,0.656,0.454
          c0.155,0.379-0.014,0.82-0.376,0.983L20,27.008L5.434,20.49z"
                      />
                      <path
                        d="M5.434,25.48c-0.362-0.164-0.531-0.604-0.376-0.981c0.113-0.275,0.372-0.454,0.659-0.454
          c0.097,0,0.191,0.021,0.282,0.061l13.967,6.25l14.037-6.25c0.09-0.039,0.186-0.061,0.283-0.061c0.286,0,0.544,0.179,0.656,0.454
          c0.155,0.378-0.014,0.819-0.375,0.981L20,32L5.434,25.48z"
                      />
                    </g>
                  </svg>
                  
    </div>
  </button>

  <button
    className="header-icon cart-icon"
    aria-label="View cart"
    onClick={() => setSidebar((s) => !s)}
  />
  <span className="icons-numbers">
    {Array.isArray(cart) ? cart.length : 0}
  </span>
</div>
              <nav>
                <ul className="nav-items">
                  <li className="position-relative megamenu-one">
                    <Link to="/shop?page=1">Shop</Link>
                    <div className="megamenu">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="megamenu-items">
                          <div className="row row-col-4">
                            {/* Megamenu categories */}
                            <div className="col">
                              <Link
                                to="/shop?category=sunshades&page=1"
                                className="megamenu-heading"
                              >
                                Sunshades
                              </Link>
                              <ul className="megamenu-list">
                                <li>
                                  <Link to="/shop?child_category=Sunshade-Mixed-Packs&page=1">
                                    Sunshade Mixed Packs
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=occy-strap&page=1">
                                    Occy-Strap
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Hose-Clamps&page=1">
                                    Hose Clamps
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?category=socket-and-ratchet-sets&page=1">
                                    Socket and Ratchet Sets
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <div className="col">
                              <Link
                                to="/shop?category=Wheel-Covers&page=1"
                                className="megamenu-heading"
                              >
                                Wheel Covers
                              </Link>
                              <ul className="megamenu-list">
                                <li>
                                  <Link to="/shop?child_category=Wheel-Trims&page=1">
                                    Wheel Trims
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Worklights&page=1">
                                    Worklights
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Wiring-Loom-Tape&page=1">
                                    Wiring Loom Tape
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Window-Winders&page=1">
                                    Window Winders
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <div className="col">
                              <Link
                                to="/shop?category=Accessories&page=1"
                                className="megamenu-heading"
                              >
                                Accessories
                              </Link>
                              <ul className="megamenu-list">
                                <li>
                                  <Link to="/shop?child_category=Back-Support&page=1">
                                    Back Support
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Seat-Cushions&page=1">
                                    Seat Cushions
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?category=car-air-fresheners&page=1">
                                    Car Air Fresheners
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=Air-Dusters--Wash-Guns&page=1">
                                    Air Dusters & Wash Guns
                                  </Link>
                                </li>
                              </ul>
                            </div>
                            <div className="col">
                              <Link
                                to="/shop?category=Tyre-Products&page=1"
                                className="megamenu-heading"
                              >
                                Tyre Products
                              </Link>
                              <ul className="megamenu-list">
                                <li>
                                  <Link to="/shop?category=Tools-and-Testing-Kits&page=1">
                                    Tools and Testing Kits
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?category=Lighting&page=1">
                                    Lighting
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?category=Tapes&page=1">
                                    Tapes
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/shop?child_category=laceup-steering-wheel-cover&page=1">
                                    Lace Up SWC
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="megamenu-image">
                          <Link to="shop?category=Tools-&-Testing-Kits&page=1">
                            <img
                              src="/assets/images/megamenu-image.webp"
                              alt=""
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="position-relative megamenu-two">
                    <Link to="/brands">All Brands</Link>
                    <div className="brand-megamenu">
                      <ul className="brand-megamenu-list">
                        {brands.map((brand) => (
                          <li key={brand.id}>
                            <Link to={`/brand?page=1&brand=${brand.permalink}`}>
                              {brand.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                  <li className="">
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  <li className="">
                    <Link to="/return-order">Return</Link>
                  </li>
                  {!user && (
                    <li className="">
                      <Link to="/guest-track-order">Track Order</Link>
                    </li>
                  )}
                  <li className="">
                    <Link to="/faqs">FAQs</Link>
                  </li>
                  <li className="position-relative megamenu-two">
                    <span
                      className="text-white"
                      style={{
                        fontWeight: 600,
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    >
                      Policy Pages
                    </span>
                    <div className="brand-megamenu">
                      <ul className="brand-megamenu-list">
                        <li>
                          <Link to={`/privacy-and-policy`}>Privacy Policy</Link>
                        </li>
                        <li>
                          <Link to={`/shipping-policy`}>Shipping Policy</Link>
                        </li>
                        <li>
                          <Link to={`/return-policy`}>Return Policy</Link>
                        </li>
                        <li>
                          <Link to={`/terms-conditions`}>
                            Terms & Conditions
                          </Link>
                        </li>
                        <li>
                          <Link to={`/editorial-guidelines`}>
                            Editorial Guidelines
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="">
                    <Link to="/blogs">Blogs</Link>
                  </li>
                </ul>
                <div className="mobile-dropdown" ref={mobileRef}>
                  <button className="mobile-menu" onClick={toggleDropdown}>
                    <FontAwesomeIcon
                      icon={isDropdownOpen ? faXmark : faBarsStaggered}
                    />
                  </button>
                  {isDropdownOpen && (
                    <ul className="mobile-menu-dropdown">
                      <li>
                        <Link to="/shop?page=1" onClick={handleLinkClick}>
                          Shop
                        </Link>
                      </li>
                      <li>
                        <Link to="/brands" onClick={handleLinkClick}>
                          All Brands
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact-us" onClick={handleLinkClick}>
                          Contact Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/return-order" onClick={handleLinkClick}>
                          Return
                        </Link>
                      </li>
                      <li>
                        <Link to="/guest-track-order" onClick={handleLinkClick}>
                          Track Order
                        </Link>
                      </li>
                      <li>
                        <Link to="/faqs" onClick={handleLinkClick}>
                          FAQs
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/privacy-and-policy"
                          onClick={handleLinkClick}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/shipping-policy" onClick={handleLinkClick}>
                          Shipping Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/return-policy" onClick={handleLinkClick}>
                          Terms & Conditions
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/editorial-guideline"
                          onClick={handleLinkClick}
                        >
                          Editorial Guidelines
                        </Link>
                      </li>
                      <li>
                        <Link to="/blogs" onClick={handleLinkClick}>
                          Blogs
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              </nav>
            </div>

            {/* <div className="category-sidebar d-flex align-items-center" >
              <button className="all-category-btn" onClick={ToggleSidebar}>
                <div
                  className="pe-2"
                  
                >
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="60px"
                    height="40px"
                    viewBox="0 0 40 40"
                    fill="#FFF"
                  >
                    <g>
                      <path
                        d="M20,21.569c-0.095,0-0.189-0.021-0.282-0.062L5.434,15.115C5.165,14.995,4.994,14.72,5,14.413
          c0.006-0.303,0.191-0.578,0.46-0.683l14.286-5.681C19.828,8.017,19.913,8,20,8c0.086,0,0.172,0.017,0.254,0.049l14.285,5.679
          c0.275,0.11,0.455,0.378,0.461,0.683c0.008,0.308-0.163,0.584-0.434,0.704L20.281,21.51C20.192,21.549,20.096,21.569,20,21.569
          L20,21.569z M7.626,14.468l12.339,5.522l12.409-5.522L20,9.549L7.626,14.468z"
                      />
                      <path
                        d="M5.434,20.49c-0.361-0.163-0.53-0.604-0.376-0.983c0.113-0.275,0.372-0.454,0.659-0.454
          c0.097,0,0.191,0.021,0.282,0.062l13.967,6.249l14.037-6.249c0.092-0.042,0.186-0.062,0.283-0.062c0.286,0,0.544,0.177,0.656,0.454
          c0.155,0.379-0.014,0.82-0.376,0.983L20,27.008L5.434,20.49z"
                      />
                      <path
                        d="M5.434,25.48c-0.362-0.164-0.531-0.604-0.376-0.981c0.113-0.275,0.372-0.454,0.659-0.454
          c0.097,0,0.191,0.021,0.282,0.061l13.967,6.25l14.037-6.25c0.09-0.039,0.186-0.061,0.283-0.061c0.286,0,0.544,0.179,0.656,0.454
          c0.155,0.378-0.014,0.819-0.375,0.981L20,32L5.434,25.48z"
                      />
                    </g>
                  </svg>
                </div>{" "}
              </button>
            </div> */}
            <div className="icon-cart d-flex">
              <div className="header-cart p-2" >
                <div className="d-flex align-items-center">
                  <div className="position-relative d-none">
                    <a href="#" className="header-icon compare-icon"></a>
                    <span className="icons-numbers">0</span>
                  </div>
                  <div className="position-relative d-none">
                    <a href="#" className="header-icon heart-icon"></a>
                    <span className="icons-numbers">0</span>
                  </div>
                  <div className="position-relative">
                    {/* <button
                      className="header-icon cart-icon"
                      aria-label="View cart"
                      onClick={() => setSidebar((s) => !s)}
                    />
                    <span className="icons-numbers">
                      {Array.isArray(cart) ? cart.length : 0}
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`cartsidebar ${sidebar ? "active" : ""}`}
        ref={cartSidebarRef}
      >
        <div className="cart-sd-header">
          <h4 className="mb-0 cartsidebar-heading">
            Shopping Cart ({cart.length})
          </h4>
          <button
            className="cartsidebar-close"
            aria-label="Close sidebar"
            onClick={closeSidebar}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className="cart-sd-body">
          {isCartEmpty ? (
            <p style={{ padding: "15px", textAlign: "center" }}>
              There are no products in the cart.
            </p>
          ) : (
            <div className="cart-sidebar-products">
              {cart.map((product, index) => (
                <div
                  key={index}
                  className="cart-sd-product d-flex justify-content-between"
                >
                  <div className="cart-sd-product-img">
                    <div>
                      <img
                        src={`${API_BASE_PUBLIC_URL}${product.featured_image}`}
                        onError={(e) => (e.target.src = productimagenotfound)}
                        width={80}
                        height={80}
                        alt={product.title}
                      />
                    </div>
                  </div>
                  <div className="cart-sd-product-detail d-flex justify-content-between">
                    <div className="sd-product-detail">
                      <h3>
                        <Link
                          to={`/product/${encodeURIComponent(
                            product.permalink
                          )}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                          className="sidebar-product-title"
                        >
                          {product.title}
                        </Link>
                      </h3>
                      <div className="d-flex align-items-center">
                        <span>X {product.quantity}</span>
                        <div className="quantity-box ms-5">
                          <input
                            type="number"
                            value={product.quantity}
                            readOnly
                          />
                          <div className="in-de-crease-btns">
                            <button
                              className="cart-increase-btn"
                              onClick={() => increaseQuantity(product)}
                            >
                              <FontAwesomeIcon icon={faAngleUp} size="2xs" />
                            </button>
                            <button
                              className="cart-decrease-btn"
                              onClick={() => decreaseQuantity(product)}
                            >
                              <FontAwesomeIcon icon={faAngleDown} size="2xs" />
                            </button>
                          </div>
                        </div>
                      </div>
                      {product.discount_data ? (
                        <p className="discounted-price">
                          ${product.discount_data.discounted_price.toFixed(2)}
                        </p>
                      ) : (
                        <p>
                          $
                          {product.product_meta &&
                          Array.isArray(product.product_meta) &&
                          product.product_meta.find(
                            (meta) => meta.option === "_price"
                          )
                            ? parseFloat(
                                product.product_meta.find(
                                  (meta) => meta.option === "_price"
                                ).value
                              ).toFixed(2)
                            : "0.00"}
                        </p>
                      )}
                    </div>
                    <div className="cart-sd-product-delete">
                      <button onClick={() => removeProduct(product.id)}>
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "#878787" }}
                          className="deleteproducticon"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isCartEmpty && (
            <div className="cart-sidebar-total">
              <div className="cart-total-one">
                <p>
                  Item {cart.length} <span>${totalPrice.toFixed(2)}</span>
                </p>
                <p className="d-none">
                  Shipping <span>$0</span>
                </p>
              </div>
              <div className="cart-total-two">
                <p>
                  Subtotal <span>${(totalPrice + 0).toFixed(2)}</span>
                </p>
                <p>
                  Total <span>${(totalPrice + 0).toFixed(2)}</span>
                </p>
                <p className="d-none">
                  Taxes: <span>$0.00</span>
                </p>
              </div>
              <div className="cart-checkout-btns">
                <Link to="/cart" onClick={closeSidebar}>
                  View Cart
                </Link>
                <Link to="/checkout" onClick={closeSidebar}>
                  Checkout
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      {sidebar && <div className="overlay"></div>}
      <div className={`sidebar ${isOpen ? "active" : ""}`}>
        <div className="sd-header">
          <h4 className="mb-0 sidebar-heading">Menu</h4>
          <button className="sidebar-close" onClick={ToggleSidebar}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        <div className="sd-body">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center p-5">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="d-flex justify-content-center">
              Error loading categories: {error.message}
            </div>
          ) : (
            <ShopSidebar
              categories={categories}
              brands={brands}
              onCategoryClick={ToggleSidebar}
            />
          )}
        </div>
      </div>
      <div
        className={`sidebar-overlay ${isOpen ? "active" : ""}`}
        onClick={ToggleSidebar}
      ></div>
    </>
  );
};

export default Navbar;
